import axios, { AxiosResponse } from 'axios';

import { env } from '../../../config';
import { History, Ticket } from '../types';

export function fetchTickets(ids: string[]): Promise<AxiosResponse<Ticket[]>> {
  return axios.post(`${env.API_URL}/dataraccov2/tickets`, {
    ids
  });
}

export function fetchHistories(id: string): Promise<AxiosResponse<History[]>> {
  return axios.get(`${env.API_URL}/dataraccov2/histories`, {
    params: {
      id
    }
  });
}
